export const pizzaData = [
    {
        id: 1,
        src: "8.jpg",
        name: "New Yorker Special",
        price: 12.28
    },
    {
        id: 2,
        src: "2.jpg",
        name: "Islamabad Deluxe Cheese",
        price: 9.99
    },
    {
        id: 3,
        src: "3.jpg",
        name: "Istanbul Organic",
        price: 15.5
    },
    {
        id: 4,
        src: "4.jpg",
        name: "Tokyo Pizza",
        price: 12.25
    },
    {
        id: 5,
        src: "5.jpg",
        name: "Amsterdam Capsicum",
        price: 13.39
    },
    {
        id: 6,
        src: "6.jpg",
        name: "Barcelona Especial",
        price: 7.52
    },
    {
        id: 7,
        src: "7.jpg",
        name: "Cape Town Special",
        price: 11.28
    },
    {
        id: 8,
        src: "1.jpg",
        name: "Buenos Aires Especial",
        price: 12.88
    },
]